var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "main__sidebar" }, [
    _c("div", { staticClass: "main__vixio" }, [
      _c(
        "div",
        {
          staticClass:
            "main__vixio-list section-border--top section-border--right section-border--bottom",
        },
        [
          _c("TitleBlock", { attrs: { text: "Global Filters" } }),
          _vm._v(" "),
          _vm._l(_vm.vocabularies, function (vocab, index) {
            return _c(
              "div",
              { key: index.key },
              [
                _c("VocabularyDropdown", {
                  key: { vocab },
                  attrs: { vocabulary: { vocab }, options: { vocab } },
                }),
              ],
              1
            )
          }),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.filters.hits && _vm.filters.hits.length,
                  expression: "filters.hits && filters.hits.length",
                },
              ],
            },
            _vm._l(_vm.filters.hits, function (item, index) {
              return _c("div", { key: index.key }, [
                _vm._v("\n          {item.id}\n        "),
              ])
            }),
            0
          ),
        ],
        2
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }